import { render, staticRenderFns } from "./WorkflowFormSubmissionCommentListItem.vue?vue&type=template&id=44b225f0&"
import script from "./WorkflowFormSubmissionCommentListItem.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormSubmissionCommentListItem.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowFormSubmissionCommentListItem.vue?vue&type=style&index=0&id=44b225f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports